<template>
  <v-row v-if="isLoading" no-gutters justify="center" class="py-12">
    <v-progress-circular color="primary" indeterminate></v-progress-circular>
  </v-row>

  <v-row v-else-if="'object' === typeof item.airtimePlan" justify="center">
    <v-col md="10" lg="8">
      <div v-if="$vuetify.breakpoint.smAndDown" class="title">
        {{ $t('message.summary') }}
      </div>
      <v-row>
        <v-col cols="12" md="6">
          <v-card outlined>
            <v-card-text>
              <v-row class="no-gutters">
                <v-col cols="12" md="6" lg="8">
                  <p>
                    <span class="font-weight-medium text-uppercase">{{ $t('message.start_date') }}</span>
                    <br />
                    {{ item.startsAt | moment('LL') }}
                  </p>
                  <p class="ma-0">
                    <span class="font-weight-medium text-uppercase">{{ $t('message.end_date') }}</span>
                    <br />
                    {{
                      $moment(item.endsAt)
                        .subtract(1, 'days')
                        .format('LL')
                    }}
                  </p>
                </v-col>
                <v-col cols="12" md="6" lg="4" class="text-right">
                  <v-btn text color="primary" @click="$emit('updateStep', 1)">{{ $t('message.change') }}</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card outlined>
            <v-card-text>
              <v-row no-gutters>
                <v-col cols="12" md="6" lg="8">
                  <p>
                    <span class="font-weight-medium text-uppercase">{{ $t('message.service') }}</span>
                    <br />
                    {{ item.airtimePlan.name }}
                    <br />
                    <template v-if="item.airtimePlan.downloadMir && item.airtimePlan.uploadMir">
                      {{ $t('message.speed') }}:
                      {{ formatSpeed(item.airtimePlan.downloadMir) }}
                      /
                      {{ formatSpeed(item.airtimePlan.uploadMir) }}
                    </template>
                    <template v-if="item.airtimePlan.downloadCir && item.airtimePlan.uploadCir">
                      <br />
                      CIR:
                      {{ formatSpeed(item.airtimePlan.downloadCir) }}
                      /
                      {{ formatSpeed(item.airtimePlan.uploadCir) }}
                    </template>

                    <template v-if="item.airtimePlan.monthlyVolume">
                      {{ $t('message.monthly_volume') }}: {{ item.airtimePlan.monthlyVolume }} GB/{{
                        $t('message.month').toLowerCase()
                      }}
                    </template>
                  </p>
                </v-col>
                <v-col v-if="false === hasInitialAirtimePlan" cols="12" md="6" lg="4" class="text-right">
                  <v-btn text color="primary" @click="$emit('updateStep', 2)">{{ $t('message.change') }}</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <template v-if="item.airtimePlan.defaultPrice && item.airtimePlan.defaultPrice.feesCount > 0">
        <div class="title mt-4">{{ $t('message.initial_charge') }}</div>
        <p>{{ $t('message.initial_charge_paragraph') }}</p>
      </template>

      <v-card v-if="item.airtimePlan.defaultPrice" outlined class="mb-6">
        <v-card-text>
          <v-row no-gutters class="mt-5">
            <v-col cols="6">
              <div class="body-2 text-uppercase">
                {{ $t('message.description') }}
              </div>
              <v-divider class="my-2"></v-divider>
              <div v-if="0 === item.airtimePlan.defaultPrice.feesCount" class="text-truncate">
                {{
                  $t('message.order_list_title', {
                    startsAt: $moment(item.startsAt).format('YYYY-MM-DD'),
                    endsAt: $moment(item.endsAt)
                      .subtract(1, 'days')
                      .format('YYYY-MM-DD'),
                    airtimePlan: item.airtimePlan.name,
                    servicePlan: agreement.servicePlan.name
                  })
                }}
              </div>
              <div v-else class="text-truncate">
                {{
                  $t('message.order_list_title', {
                    startsAt: $moment(item.startsAt).format('YYYY-MM-DD'),
                    endsAt: $moment(item.startsAt)
                      .endOf('month')
                      .format('YYYY-MM-DD'),
                    airtimePlan: item.airtimePlan.name,
                    servicePlan: agreement.servicePlan.name
                  })
                }}
              </div>
            </v-col>

            <v-col class="text-right">
              <div class="body-2 text-uppercase">
                {{ $t('message.vat') }}
              </div>
              <v-divider class="my-2"></v-divider>
              {{ item.airtimePlan.defaultPrice.initialCharge.tax }}%
            </v-col>
            <v-col cols="3" class="text-right">
              <div class="body-2 text-uppercase text-truncate pl-6">
                {{ $t('message.net_total') }}
              </div>
              <v-divider class="my-2"></v-divider>
              {{ $n(item.airtimePlan.defaultPrice.initialCharge.netPrice, agreement.currency.code) }}
            </v-col>
          </v-row>
          <v-row justify="end">
            <v-col cols="auto">
              <table class="text-right">
                <tr>
                  <td class="py-1">{{ $t('message.net_total') }}:</td>
                  <td class="py-1 pl-4">
                    {{ $n(item.airtimePlan.defaultPrice.initialCharge.netPrice, agreement.currency.code) }}
                  </td>
                </tr>
                <tr>
                  <td class="py-1">{{ $t('message.vat') }} ({{ item.airtimePlan.defaultPrice.total.tax }}%):</td>
                  <td class="py-1 pl-4">
                    {{ $n(item.airtimePlan.defaultPrice.initialCharge.taxAmount, agreement.currency.code) }}
                  </td>
                </tr>
                <tr v-if="0 === item.airtimePlan.defaultPrice.feesCount">
                  <td class="py-1">{{ $t('message.gross_total') }}:</td>
                  <td class="py-1 pl-4 body-2">
                    {{ $n(item.airtimePlan.defaultPrice.initialCharge.grossPrice, agreement.currency.code) }}
                  </td>
                </tr>
                <tr v-else>
                  <td class="py-1 font-weight-black black--text">{{ $t('message.gross_total_initial') }}:</td>
                  <td class="py-1 pl-4 body-2 font-weight-black black--text">
                    {{ $n(item.airtimePlan.defaultPrice.initialCharge.grossPrice, agreement.currency.code) }}
                  </td>
                </tr>
                <tr v-if="!isBalanceExceeded(item.airtimePlan.balance)">
                  <td class="py-1">
                    {{
                      $t('message.total_spending_balance', {
                        daysNumber:
                          $moment(item.endsAt)
                            .subtract(1, 'days')
                            .diff($moment(item.startsAt), 'days') + 1
                      })
                    }}
                  </td>
                  <td class="py-1 pl-4 body-2">
                    {{ $n(0, agreement.currency.code) }}
                  </td>
                </tr>
              </table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <template v-if="item.airtimePlan.defaultPrice && item.airtimePlan.defaultPrice.feesCount > 0">
        <div class="title mt-4">{{ $t('message.monthly_fee') }}</div>
        <p>
          {{
            $t('message.monthly_fee_paragraph', {
              month: $moment(item.endsAt)
                .subtract(1, 'days')
                .format('MMMM'),
              year: $moment(item.endsAt)
                .subtract(1, 'days')
                .format('YYYY')
            })
          }}
        </p>

        <v-card outlined class="mb-6">
          <v-card-text>
            <v-row no-gutters class="mt-5">
              <v-col cols="6">
                <div class="body-2 text-uppercase">
                  {{ $t('message.description') }}
                </div>
                <v-divider class="my-2"></v-divider>
                <div class="text-truncate">{{ agreement.servicePlan.name }} - {{ item.airtimePlan.name }}</div>
              </v-col>

              <v-col class="text-right">
                <div class="body-2 text-uppercase">
                  {{ $t('message.vat') }}
                </div>
                <v-divider class="my-2"></v-divider>
                {{ item.airtimePlan.defaultPrice.monthlyFee.tax }}%
              </v-col>
              <v-col cols="3" class="text-right">
                <div class="body-2 text-uppercase text-truncate pl-6">
                  {{ $t('message.net_total') }}
                </div>
                <v-divider class="my-2"></v-divider>
                {{ $n(item.airtimePlan.defaultPrice.monthlyFee.netPrice, agreement.currency.code) }}
              </v-col>
            </v-row>
            <v-row justify="end">
              <v-col cols="auto">
                <table class="text-right">
                  <tr>
                    <td class="py-1">{{ $t('message.net_total') }}:</td>
                    <td class="py-1 pl-4">
                      {{ $n(item.airtimePlan.defaultPrice.monthlyFee.netPrice, agreement.currency.code) }}
                    </td>
                  </tr>
                  <tr>
                    <td class="py-1">{{ $t('message.vat') }} ({{ item.airtimePlan.defaultPrice.total.tax }}%):</td>
                    <td class="py-1 pl-4">
                      {{ $n(item.airtimePlan.defaultPrice.monthlyFee.taxAmount, agreement.currency.code) }}
                    </td>
                  </tr>
                  <tr>
                    <td class="py-1">{{ $t('message.gross_total_monthly') }}:</td>
                    <td class="py-1 pl-4 body-2">
                      {{ $n(item.airtimePlan.defaultPrice.monthlyFee.grossPrice, agreement.currency.code) }}
                    </td>
                  </tr>
                  <tr v-if="!isBalanceExceeded(item.airtimePlan.balance)">
                    <td class="py-1">
                      {{
                        $t('message.total_spending_balance', {
                          daysNumber:
                            $moment(item.endsAt)
                              .subtract(1, 'days')
                              .diff($moment(item.startsAt), 'days') + 1
                        })
                      }}
                    </td>
                    <td class="py-1 pl-4 body-2">
                      {{ $n(0, agreement.currency.code) }}
                    </td>
                  </tr>
                </table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>

      <v-row justify="center">
        <v-btn class="ma-3" @click="$emit('updateStep', false === hasInitialAirtimePlan ? 2 : 1)">{{
          $t('message.back')
        }}</v-btn>
        <v-btn color="primary" class="ma-3" @click="$emit('updateStep', false === hasInitialAirtimePlan ? 4 : 3)">{{
          $t('message.continue')
        }}</v-btn>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import fetch from '@/utils/fetch'

export default {
  name: 'Summary',
  props: {
    agreement: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    hasInitialAirtimePlan: {
      type: Boolean,
      required: false,
      default: false
    },
    airtimeBalancesMerged: {
      type: Array,
      required: false,
      default: null
    }
  },

  data() {
    return {
      isLoading: false
    }
  },

  mounted() {
    if (true === this.hasInitialAirtimePlan && 'object' === typeof this.item.airtimePlan) {
      const startsAt = this.$moment(this.item.startsAt)
        .tz('Europe/Madrid')
        .set({ hour: 8, minutes: 0, second: 0, millisecond: 0 })
        .format('YYYY-MM-DD HH:mm:ss')
      const endsAt = this.$moment(this.item.endsAt)
        .tz('Europe/Madrid')
        .set({ hour: 8, minutes: 0, second: 0, millisecond: 0 })
        .format('YYYY-MM-DD HH:mm:ss')
      const agreementId = this.agreement.id

      let airtimePlanId = this.item.airtimePlan['@id']

      const balance = this.airtimeBalancesMerged.filter(balance => {
        return balance.airtimePlan['@id'] === airtimePlanId
      })[0]

      this.airtimePlan = {}
      this.airtimePlan.defaultPrice = null

      this.isLoading = true
      fetch(airtimePlanId)
        .then(response => {
          return response.json()
        })
        .then(data => {
          this.item.airtimePlan = data
          this.item.airtimePlan.balance = balance

          let url =
            airtimePlanId + '/default_price?startsAt=' + startsAt + '&endsAt=' + endsAt + '&agreement=' + agreementId
          fetch(url)
            .then(response => {
              return response.json()
            })
            .then(data => {
              this.item.airtimePlan.defaultPrice = data
              this.isLoading = false
            })
            .catch(e => {
              // eslint-disable-next-line no-console
              console.log(e)
              this.isLoading = false
            })
        })
        .catch(e => {
          console.log(e)
          this.isLoading = false
        })
    }
  },

  methods: {
    formatSpeed(value) {
      if (value >= 1024) {
        return this.$n(value / 1024) + ' Mbps'
      }

      return this.$n(value) + ' kbps'
    },
    isBalanceExceeded(airtimeBalance) {
      if (!airtimeBalance) {
        return true
      }
      return (
        this.$moment(this.item.endsAt)
          .subtract(1, 'days')
          .diff(this.$moment(this.item.startsAt), 'days') >= airtimeBalance.remainingDays
      )
    }
  }
}
</script>
